import { FooterDisclaimerItemFragment } from '@sanity/graphql/queries/fragments';
import gql from 'graphql-tag';
import { RelatedArticlesSectionFragment } from './blog-education-center';

export const ModularLandingPageQuery = gql`
	query ModularLandingPageBySlug($slug: String!) {
		allModularLandingPage(where: { slug: { current: { eq: $slug } } }) {
			_id
			pageTitle
			pageSummary
			showMainNav
			showFullFooter
			components {
				__typename
				... on CtaPanel {
					_key
					_type
					ctaHeading
					ctaSummary
					ctaLink {
						url
						linkText
						openInNewTab
					}
				}
				... on InfoCardsSection {
					_key
					_type
					panelHeading
					panelOverline
					sectionSummary
					isSectionDarkTheme
					sectionCards {
						image {
							asset {
								url
								altText
							}
						}
						heading
						title
						description
						link {
							url
							linkText
							openInNewTab
						}
					}
				}
				... on InfoCard {
					_key
					_type
					image {
						asset {
							url
							altText
						}
					}
					heading
					title
					description
					link {
						url
						linkText
						openInNewTab
					}
				}
				... on LandingPageHero {
					_key
					_type
					stub
					backgroundColor {
						hex
					}
					isDarkTheme
					heading
					description
					image {
						asset {
							url
						}
					}
					isHeroImageRightAligned
					disclaimer: disclaimerRaw
					showLeadCapture
					presetPlanID
					leadCaptureHeading
					leadCaptureSubheading
					leadCaptureMetadata {
						leadCaptureMetadataHeading
						leadCaptureMetadataSubheading
					}
					leadCaptureButtonText
					thirdPartyAuthTheme
					campaignLogo {
						asset {
							url
						}
					}
					feeWaiverKey
					includeSolicitorNotice
					solicitorName
					isInvestor
					isCPAPartner
					maxCPAPayment
					monthlyPayment
				}
				... on ReusableContent {
					_type
					type
				}
				... on RelatedArticles {
					...RelatedArticlesSectionFragment
					_type
				}
				... on ToutsPanel {
					_type
					panelOverline
					panelHeading
					panelSummary
					panelTouts {
						toutHeading
						toutSummary
						toutCta {
							url
							linkText
							openInNewTab
						}
					}
				}
			}
			footerDisclaimers {
				...FooterDisclaimerItemFragment
			}
		}
	}
	${FooterDisclaimerItemFragment}
	${RelatedArticlesSectionFragment}
`;
